module.exports = __webpack_public_path__ + "img/check1.4c5b494a.svg";